import { Component, OnInit, ViewChild } from '@angular/core';
import { Congreso } from '../../../models/congreso.model';
import { ActivatedRoute, Router } from '@angular/router';
import { CongresosService, NotificationsService } from '../../../services/services.index';
import { Notification } from '../../../models/notification.model';

import { CKEditorComponent } from 'ng2-ckeditor';

import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;

@Component({
  selector: 'app-notification-edit',
  templateUrl: './notification-edit.component.html',
  styles: []
})
export class NotificationEditComponent implements OnInit {

  congreso: Congreso = new Congreso();
  loading: boolean = true;
  notification: Notification = new Notification();

  @ViewChild(CKEditorComponent) ckeditor: CKEditorComponent;

  constructor(private activatedRoute: ActivatedRoute,
    public _congresosService: CongresosService,
    public _notificationService: NotificationsService,
    public router: Router) { }

  ngOnInit() {
    this.loading = true;
    this.activatedRoute.params.subscribe( params => {
      let congresoId: any = params['congreso'];
      let notificationId: any = params['notification'];
      this._congresosService.getCongreso(congresoId).subscribe((data: any) => {
        this.congreso = data.congreso;
        if (notificationId !== 'new') {
          this.loadNotification(notificationId);
        }
        this.loading = false;
      });
    });
  }

  ngAfterViewChecked() {
    let editor = this.ckeditor.instance;
    editor.config.height = '300';

    editor.config.toolbarGroups = [
      { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
      { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
      { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
      { name: 'forms', groups: [ 'forms' ] },
      '/',
      { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
      { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
      { name: 'links', groups: [ 'links' ] },
      { name: 'insert', groups: [ 'insert' ] },
      '/',
      { name: 'styles', groups: [ 'styles' ] },
      { name: 'colors', groups: [ 'colors' ] },
      { name: 'tools', groups: [ 'tools' ] },
      { name: 'others', groups: [ 'others' ] },
      { name: 'about', groups: [ 'about' ] }
    ];
    editor.config.removeButtons = 'Source,Save,Templates,Cut,Copy,NewPage,Preview,Print,Paste,PasteText,PasteFromWord,Find,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Bold,Strike,CopyFormatting,NumberedList,BulletedList,Outdent,Indent,Blockquote,CreateDiv,JustifyLeft,JustifyCenter,JustifyRight,JustifyBlock,BidiLtr,BidiRtl,Language,Link,Unlink,Anchor,Image,Flash,Table,HorizontalRule,Smiley,PageBreak,Iframe,Styles,Format,Font,FontSize,TextColor,BGColor,Maximize,ShowBlocks,About,SpecialChar';
  }

  guardarNotification() {
    this.notification.congreso = this.congreso._id;
    console.log(this.notification);
    this._notificationService.guardarNotification(this.notification).subscribe(resp => {
      console.log(resp);
      swal('Notificacion Guardada', 'La notificación fue guardada correctamente.', 'success');
      this.router.navigate(['/notifications', this.congreso._id]);
    });
  }

  loadNotification(notification_id: string) {
    this.loading = true;
    this._notificationService.getNotification(notification_id).subscribe((resp: any) => {
      this.notification = resp.notification;
      this.loading = false;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/notifications/notification-edit/notification-edit.component.ts